__turbopack_context__.v({
  "combineImageButton": "imageCombine-module__fykneG__combineImageButton",
  "combineImgNew": "imageCombine-module__fykneG__combineImgNew",
  "combineImgOptionAlignment": "imageCombine-module__fykneG__combineImgOptionAlignment",
  "horizonakalAlignment": "imageCombine-module__fykneG__horizonakalAlignment",
  "imageCombineAlignment": "imageCombine-module__fykneG__imageCombineAlignment",
  "inputBoxAlignment": "imageCombine-module__fykneG__inputBoxAlignment",
  "selectImgBoxAlignment": "imageCombine-module__fykneG__selectImgBoxAlignment",
  "verticalBoxAlignment": "imageCombine-module__fykneG__verticalBoxAlignment",
  "verticalGrid": "imageCombine-module__fykneG__verticalGrid",
  "verticalselectImgBoxAlignment": "imageCombine-module__fykneG__verticalselectImgBoxAlignment",
});
